import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { animateScroll } from 'react-scroll'
import block from 'bem-cn'

import logo from 'shared/img/logo.webp'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'

import { AgentLinkButton } from 'components/AgentLinkButton/AgentLinkButton'
import UserBlock from 'components/Header/desktop/UserBlock/UserBlock'
import { PromotionsButton } from 'components/PromotionsButton/PromotionsButton'
import SetLanguage from 'components/SetLanguage/SetLanguage'

import './TopHeader.scss'

const b = block('top-header-mobile')

const TopHeader: React.FC = () => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  return (
    <div className={b()}>
      <div className={b('left')}>
        <Link to="/" className={b('logo-link')} aria-label={locale.home} onClick={() => animateScroll.scrollToTop()}>
          <img src={logo} className={b('logo')} alt="logo" />
        </Link>
        <SetLanguage />
      </div>
      <div className={b('right')}>
        {isAuth && <PromotionsButton />}
        <AgentLinkButton isStatic />
        <UserBlock />
      </div>
    </div>
  )
}

export default TopHeader
